import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services';
import { combineLatest, Subject } from 'rxjs';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { AMPubscriptionModel, GetAMPSubscription, IAMPModifySubscriptionResponse, IAMPOrdersByCustomerResponse } from '../../../../../models/amp.model';
import { AdobeService } from '../../../../../services/adobe.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { FinishAMPSubscriptionComponent } from '../../../../../popup-collection/finish-amp-subscription/finish-amp-subscription.component';
import { ApiResponse } from '../../../../../models/api-response.model';

@Component({
  selector: 'app-amp-subscription-cancellation',
  templateUrl: './amp-subscription-cancellation.component.html',
  styleUrls: ['./amp-subscription-cancellation.component.css'],
  providers: [DatePipe]
})
export class AMPSubscriptionCancellationComponent implements OnInit {

  public tenantId: string;
  public offerId: string;
  public editMode = true;
  public tableLoading = true;
  public scopeId: string;
  public budget: any;
  public sub: GetAMPSubscription;

  public tableResult: IAMPOrdersByCustomerResponse[]

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public markDisabled = (date: NgbDate) => { return this.calendar.getWeekday(date) >= 0 };

  public displayedColumns: string[] = [
    'orderId',
    'stockCode',
    'custReference',
    'createdTime',
    'lineItemNumber',
    'qty',
    'cancelButton'
  ];


  constructor(
    private adobeService: AdobeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public calendar: NgbCalendar,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) {}

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 + $('#manageAMPSubscription').width()}, 400);
  }

  ngOnInit() {
    combineLatest([
      this.activatedRoute.parent.parent.params,
      this.activatedRoute.parent.params,
      this.activatedRoute.params,
      this.adobeService.getCurrentAMPSubscriptions
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([tenantParams, subIdpraram, subParams, subs]) => {
        this.tenantId = tenantParams['tenantId'];
        this.offerId = subParams['offerId'];
        const subscriptionId = subIdpraram['subId'];

        if (subs?.length) {
          this.sub = subs.find(s => s.out_subscription_id == subscriptionId);
        }
        
        this.getAMPCancellationItems();
      });
  }

  public getAMPCancellationItems() {
    //  14 days before
    const startDate =  this.datePipe.transform(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
    this.tableLoading = true;
    this.adobeService.getAMPOrdersByCustomer(
      this.tenantId,
      '',
      startDate
    )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: IAMPOrdersByCustomerResponse[]) => {
        this.tableResult = [ ...res ].filter(r => r.subscriptionId.toLowerCase() == this.sub.out_subscription_id.toLowerCase())
        this.tableLoading = false;
      },
        (error: any) => {
          this.tableLoading = false;
        });
  }

  cancelAMPSub(sub: IAMPOrdersByCustomerResponse, index: number): void {
    const confirmAnnuityItemSubscription = {
      tenantId: this.tenantId,
      qty: this.sub.out_qty?.toString(),
      orderId: sub.orderId,
      offerId: sub.offerId,
      subscriptionId: this.sub.out_subscription_id,
      parentSubscriptionId: this.sub.out_subscription_id,
      cancelQty: sub.quantity.toString(),
      stockCode: sub.offerId,
      lineItemId: sub.extLineItemNumber.toString(),
      subscriptionDescription: this.sub.out_stk_description,
      orderType: 'RETURN'
    } as AMPubscriptionModel;
    this.tableResult[index].isCancelling = true;
    this.adobeService.createOrCancelAMPSubscription([confirmAnnuityItemSubscription])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: IAMPModifySubscriptionResponse[] | ApiResponse) => {
        if ('responseMessage' in res && !(res as ApiResponse)?.status ) {
          this.commonService.implementToast(res.responseMessage, 'Error');
        } else {
          let validResponse = res as IAMPModifySubscriptionResponse[];
          this.tableResult[index].isCancelling = false;
            if (validResponse.length) {
              const dialogRefFinish = this.dialog.open(FinishAMPSubscriptionComponent, {
                width: '650px',
                data: { finishSubscriptions: validResponse, confirmSubscriptions: [confirmAnnuityItemSubscription], type: 'Return' },
                disableClose: true
              });

              dialogRefFinish.afterClosed().subscribe(() => {
                this.adobeService.refetchAMPItemsView$.next();
                this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP/AMPDetails/' + this.tenantId);
              });
            };
        }
      },
        (error: any) => {
          this.commonService.implementToast(error?.Message, "Error")
          this.tableResult[index].isCancelling = false;
        });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
    this.router.navigate([`../../`], { relativeTo: this.activatedRoute });
  }

}
